











 














const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UpdateIntegrationProviderMutation_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "provider",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "webhookUrl",
              "storageKey": null
            }
          ],
          "type": "IntegrationProviderWebhook",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serverBaseUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "clientId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "tenantId",
              "storageKey": null
            }
          ],
          "type": "IntegrationProviderOAuth2",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UpdateIntegrationProviderSuccess",
  "abstractKey": null
};

(node ).hash = "5c872f24c1ec1db2ae9c2325c92a6c6c";

export default node;
